import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import fetchSalon from 'actions/fetchSalon.action';
import beInitReaderPayment from 'actions/pos/beInitReaderPayment.action';
import feSetPosIntentId from 'actions/pos/feSetPosIntentId.action';
import AsyncFunctionExample from 'components/experiment/hooks/AsyncFunctionExample.component';
import DialogExample from 'components/experiment/hooks/DialogExample.component';
import EffectExample from 'components/experiment/hooks/EffectExample.component';
import ResetExample from 'components/experiment/hooks/ResetExample.component';
import TextExample from 'components/experiment/hooks/TextExample.component';
import useCounter from 'hooks/useCounter.hook';
import { selectCheckoutPos } from 'selectors/checkout.selectors';
import { selectCurrentSalonFlags, selectCurrentSalonPosFlow } from 'selectors/currentSalon.selectors';
import { fromPropsToMatchedSalonId } from 'utils/converters/props/bl.util';
import logger from 'utils/logger.util';

import CN from './HooksPage.module.scss';

const L = logger('HooksPage');

const HooksPage = (props) => {
  const salonId = fromPropsToMatchedSalonId(props);

  const { val: counter, inc: handleIncrement, set: handleSet } = useCounter(1);

  L.debug('()', { salonId });

  return (
    <div data-bem="HooksPage" className={CN.component}>
      <AsyncFunctionExample />
      <TextExample />
      <ResetExample counter={counter} onChange={handleSet} onIncrement={handleIncrement} />
      <DialogExample counter={counter} onChange={handleSet} title="Good Example" />
      <DialogExample counter="missing" onChange={handleSet} title="Bad Example" />
      <EffectExample counter={counter} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  posFlow: selectCurrentSalonPosFlow(state),
  salonFlags: selectCurrentSalonFlags(state),
  pos: selectCheckoutPos(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSalon,
      beInitReaderPayment,
      feSetPosIntentId,
    },
    dispatch,
  );

// noinspection JSUnusedGlobalSymbols
export default connect(mapStateToProps, mapDispatchToProps)(HooksPage);
